import products from './@products'
import prompt from './prompt'
import common from './common'
import repositories from './@repositories';
import parcel from './@parcel'
import document from './@document'
import configuration from './@configuration'
import report from './@report'

export default {
  [`@products`]: products,
  [`prompt`]: prompt,
  [`common`]: common,
  [`@repositories`]: repositories,
  [`@parcel`]: parcel,
  [`@document`]: document,
  [`@configuration`]: configuration,
  [`@report`]: report,

};